/* eslint-disable no-useless-escape */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { 
    selectDrivers
} from '../features/drivers/driversSlice'
import {
    addPayrollData
} from '../features/payroll/payrollSlice'

const GetInvoice = (props) => {
    // function for getting the week
    // eslint-disable-next-line no-extend-native
    Date.prototype.getWeek = function () {
        var firstDate = new Date(this.getFullYear(), 0, 1)
        if (this.getFullYear() === 2021) {
            return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7) - 1
        } else {
            return Math.ceil((((new Date(this.getFullYear(), this.getMonth(), this.getDate()) - firstDate) / 86400000) + firstDate.getDay() + 1) / 7)
        }
    }

    // allow for dispatching
    const dispatch = useDispatch();

    // set the current date
    const [ currentDate ] = useState(new Date())

    // grab redux drivers
    const reduxDrivers = useSelector(selectDrivers)

    // api functions
    var CryptoJS = require("crypto-js");
    async function postData(url = '', data = {}) {
        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
        let originalText = bytes.toString(CryptoJS.enc.Utf8);
        const response = await fetch(url, {
            method: 'POST', 
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${originalText}`
            },
            body: JSON.stringify(data)
        });
        return response ? response.json() : console.log('no reponse')
    };
    async function getData(url = '') {
        let bytes  = CryptoJS.AES.decrypt(localStorage.getItem('token'), process.env.REACT_APP_ENCRYPTION_TYPE);
        let originalText = bytes.toString(CryptoJS.enc.Utf8);
        const response = await fetch(url, {
            method: 'GET', 
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${originalText}`
            },
        });
        return response ? response.json() : console.log('no reponse')
    };

    // onle one week
    // for grabbing all of the dates
    useEffect( () => {
        if (props.dateSelection) {
            if (reduxDrivers.length > 0) {
                let driverArray = [...reduxDrivers]
                let deductionsArray = []
                let supportArray = []
                let dateInner = props.dateSelection
                while (dateInner.getDay() !== 0) {
                    dateInner = new Date(dateInner.getFullYear(), dateInner.getMonth(), dateInner.getDate() - 1)
                }
                if (dateInner.getDay() === 0) {
                    let theDateWeek = new Date(dateInner).getWeek()
                    // deductions section
                    postData('https://backendpajamas.herokuapp.com/deductionschedule/', {
                        date: dateInner.toDateString(),
                        week: theDateWeek
                    }).then( response => {
                        deductionsArray = response.data
                        // support
                        postData('https://backendpajamas.herokuapp.com/supportschedule/', {
                            date: dateInner.toDateString(),
                            week: theDateWeek
                        }).then( response => {
                            supportArray = response.data
                            // dates
                            postData('https://backendpajamas.herokuapp.com/weekschedule/', {
                                date: dateInner.toDateString(),
                                week: theDateWeek
                            }).then( response => {
                                // sort the deductions and support to the dates
                                // deductions
                                response.data.forEach( date => {
                                    let localDeductionSum = 0
                                    date.deductionList=[]
                                    deductionsArray.forEach( deduction => {
                                        if (deduction.date_id.match(/schedule.*[^\/]/g)[0].replace(/schedule\//, '') === date.date_id) {
                                            date.deductionList.push(deduction)
                                            localDeductionSum+=parseFloat(deduction.amount.slice(3))
                                        }
                                    })
                                    date.deductionSum = `GB£${localDeductionSum}`
                                })

                                // supports
                                response.data.forEach( date => {
                                    let localSupportSum = 0
                                    date.supportList = []
                                    supportArray.forEach( support => {
                                        if (support.date_id.match(/schedule.*[^\/]/g)[0].replace(/schedule\//, '') === date.date_id) {
                                            if (date.supportList) {
                                                date.supportList.push(support)
                                                localSupportSum+=parseFloat(support.amount.slice(3))
                                            }
                                        }
                                    })
                                    date.supportSum = `GB£${localSupportSum}`
                                })

                                // sort the dates to drivers
                                let finalObj = {
                                    'DBS2': [],
                                    'DCF1': [],
                                    'DRR1': [],
                                    'DEX2': [],
                                    'DXP1': [],
                                    'DSN1': [],
                                    'Other': []
                                }

                                response.data.forEach( date => {
                                    let location = ''
                                    driverArray.forEach( driver => {
                                        let localDriverTwo = {...driver}
                                        localDriverTwo.datesList = []
                                        if (date.driver_id) {
                                            if (localDriverTwo.driver_id === parseInt(date.driver_id.match(/\d+/g)[0])) {
                                                if (date.location === 'CT' || date.location === 'RT') {
                                                    location = localDriverTwo.location
                                                } else {
                                                    location = date.location
                                                }
                                                let localGate = true
                                                if (finalObj[location]) {
                                                    finalObj[location].forEach( (driverInner, driverInnerId) => {
                                                        if (driverInner.driver_id === localDriverTwo.driver_id) {
                                                            localGate = false
                                                            finalObj[location][driverInnerId].datesList.push(date)
                                                        }
                                                    })
                                                    if (localGate) {
                                                        let localDriver = {...driver}
                                                        localDriver.datesList = [...localDriver.datesList, date]
                                                        finalObj[location].push(localDriver)
                                                    }
                                                }
                                            }
                                        }
                                    })
                                })

                                let checkerNameArray = []      
                                for (let localObject in finalObj) {
                                    finalObj[localObject].forEach( element => {
                                        if (!checkerNameArray.includes(element['driver_id'])) {
                                            element['datesList'][0]['adminCharge'] = 8.33
                                            checkerNameArray.push(element['driver_id'])
                                        }
                                    })
                                }
                                let name = dateInner.toDateString()
                                let myObj = {}
                                myObj[`${name}`] = {
                                    'data': finalObj
                                }
                                dispatch(addPayrollData({
                                    payload: myObj[`${name}`].data,
                                    name: `${name}`
                                }))
                            })
                        })
                    })
                }
            } else {
                getData('https://backendpajamas.herokuapp.com/drivers/').then( response => {
                    let driverArray = response.results
                    let deductionsArray = []
                    let supportArray = []
                    let dateInner = props.dateSelection
                    while (dateInner.getDay() !== 0) {
                        dateInner = new Date(dateInner.getFullYear(), dateInner.getMonth(), dateInner.getDate() - 1)
                    }
                    if (dateInner.getDay() === 0) {
                        let theDateWeek = new Date(dateInner).getWeek()
                        // deductions section
                        postData('https://backendpajamas.herokuapp.com/deductionschedule/', {
                            date: dateInner.toDateString(),
                            week: theDateWeek
                        }).then( response => {
                            deductionsArray = response.data
                            // support
                            postData('https://backendpajamas.herokuapp.com/supportschedule/', {
                                date: dateInner.toDateString(),
                                week: theDateWeek
                            }).then( response => {
                                supportArray = response.data
                                // dates
                                postData('https://backendpajamas.herokuapp.com/weekschedule/', {
                                    date: dateInner.toDateString(),
                                    week: theDateWeek
                                }).then( response => {

                                    // sort the deductions and support to the dates
                                    // deductions
                                    response.data.forEach( date => {
                                        let localDeductionSum = 0
                                        date.deductionList=[]
                                        deductionsArray.forEach( deduction => {
                                            if (deduction.date_id.match(/schedule.*[^\/]/g)[0].replace(/schedule\//, '') === date.date_id) {
                                                date.deductionList.push(deduction)
                                                localDeductionSum+=parseFloat(deduction.amount.slice(3))
                                            }
                                        })
                                        date.deductionSum = `GB£${localDeductionSum}`
                                    })

                                    // supports
                                    response.data.forEach( date => {
                                        let localSupportSum = 0
                                        date.supportList = []
                                        supportArray.forEach( support => {
                                            if (support.date_id.match(/schedule.*[^\/]/g)[0].replace(/schedule\//, '') === date.date_id) {
                                                if (date.supportList) {
                                                    date.supportList.push(support)
                                                    localSupportSum+=parseFloat(support.amount.slice(3))
                                                }
                                            }
                                        })
                                        date.supportSum = `GB£${localSupportSum}`
                                    })

                                    // sort the dates to drivers
                                    let finalObj = {
                                        'DBS2': [],
                                        'DCF1': [],
                                        'DRR1': [],
                                        'DEX2': [],
                                        'DXP1': [],
                                        'DSN1': [],
                                        'Other': []
                                    }

                                    response.data.forEach( date => {
                                        let location = ''
                                        driverArray.forEach( driver => {
                                            driver.datesList = []
                                            if (date.driver_id) {
                                                if (driver.driver_id === parseInt(date.driver_id.match(/\d+/g)[0])) {
                                                    if (date.location === 'CT' || date.location === 'RT') {
                                                        location = driver.location
                                                    } else {
                                                        location = date.location
                                                    }
                                                    let localGate = true
                                                    if (finalObj[location]) {
                                                        finalObj[location].forEach( (driverInner, driverInnerId) => {
                                                            if (driverInner.driver_id === driver.driver_id) {
                                                                localGate = false
                                                                finalObj[location][driverInnerId].datesList.push(date)
                                                            }
                                                        })
                                                        if (localGate) {
                                                            let localDriver = {...driver}
                                                            localDriver.datesList.push(date)
                                                            finalObj[location].push(localDriver)
                                                        }
                                                    }
                                                }
                                            }
                                        })
                                    })

                                    let checkerNameArray = []      
                                    for (let localObject in finalObj) {
                                        finalObj[localObject].forEach( element => {
                                            if (!checkerNameArray.includes(element['driver_id'])) {
                                                element['datesList'][0]['adminCharge'] = 8.33
                                                checkerNameArray.push(element['driver_id'])
                                            }
                                        })
                                    } 
                                    let name = dateInner.toDateString()
                                    let myObj = {}
                                    myObj[`${name}`] = {
                                        'data': finalObj
                                    }
                                    dispatch(addPayrollData({
                                        payload: myObj[`${name}`].data,
                                        name: `${name}`
                                    }))
                                })
                            })
                        })
                    }
                })
            }
        }
    }, [props.dateSelection])

    return(
        <>
        </>
    )
}

export default GetInvoice